import styled, { css } from "styled-components";

import Props from "./props";
import Wrapper from "../Loader/Wrapper";

const StyledButton = styled.a<Props>`
    position: relative;
    cursor: pointer;
    border: none;
    margin: 0;
    padding: 0;
    font-size: 0.875rem;
    line-height: 2.25rem;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    outline: none;
    padding: 0 1rem;
    border-radius: 0.2rem;
    transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1), padding 280ms cubic-bezier(0.4, 0, 0.2, 1);
    height: 2.25rem;
    min-width: 4rem;
    display: inline-block;
    text-decoration: none;
    ${(props: Props) => {
        if (props.primary) {
            return css`
                background-color: ${props => props.theme.colors.primary(1)};
                color: ${props => props.theme.colors.primaryInvert(1)};
            `;
        } else if (props.light) {
            return css`
                background-color: ${props => props.theme.colors.light(1)};
                color: ${props => props.theme.colors.lightInvert(1)};
            `;
        } else {
            return css`
                background-color: ${props => props.theme.colors.white(0)};
                color: ${props => props.theme.colors.black(1)};
            `;
        }
    }}
    ${({ uppercase }) =>
        uppercase &&
        css`
            text-transform: uppercase;
        `}
    ${({ shadow }) =>
        shadow &&
        css`
            box-shadow: 0px 3px 1px -2px ${props => props.theme.colors.black(0.2)}, 0px 2px 2px 0px ${props => props.theme.colors.black(0.14)},
                0px 1px 5px 0px ${props => props.theme.colors.black(0.12)};
        `}
    &:hover {
        ${({ shadow }) =>
            shadow &&
            css`
                box-shadow: 0px 2px 4px -1px ${props => props.theme.colors.black(0.2)}, 0px 4px 5px 0px ${props => props.theme.colors.black(0.14)},
                    0px 1px 10px 0px ${props => props.theme.colors.black(0.12)};
            `}
    }
    ${({ isLoading }) =>
        isLoading &&
        css`
            padding: 0 2.7rem 0 1rem;
            opacity: 0.6;
            pointer-events: none;
        `}
    ${Wrapper} {
        position: absolute;
        width: 1rem;
        top: 50%;
        right: 1rem;
        transform: translateY(-50%);
    }
`;

export default StyledButton;
